import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import Loader from './shared/loader/loader';

const App: React.FC = ({ children }: any) => {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return <Loader />;
  }

  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <div className="page-body-wrapper">{children}</div>
    </div>
  );
};

export default App;